import { useDevelopmentProgramFundings } from "@/lib/api";
import { MenuItem, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { useEffect } from "react";
import SelectStyled from "../SelectStyled";

export const DevelopmentProgramFundingSelector = ({ name, label, onChange }) => {
    const { fundings, isLoading, isError } = useDevelopmentProgramFundings();
    const [ fundingsToDisplay, setFundingsToDisplay ] = useState([]);

    useEffect(() => {
        if (isLoading || isError) {
            return;
        }

        let newList = [];
        for (const f of fundings) {
            if (newList.findIndex(o => o === f.funding) === -1) {
                newList = [...newList, f.funding];
            }
        }
        setFundingsToDisplay(newList.sort((a,b) => {
            const nameA = a.toLowerCase();
            const nameB = b.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        }));

    }, [fundings]);

    const handleSelected = (event) => {
        if (onChange) {
            onChange(event);
        }
    }

    if (isLoading) {
        return <Skeleton />
    }

    return (
        <>
            <SelectStyled
                fullWidth
                name={name}
                label={label}
                placeholder="Alle Fördereinrichtungen"
                variant="filled"
                inputProps={{ "aria-label": "Art der Förderung" }}
                onChange={handleSelected}
            >
                <MenuItem value="">Alle Fördereinrichtungen</MenuItem>
                {fundingsToDisplay.map((f, idx) => {
                    return <MenuItem key={idx} value={f}>{f}</MenuItem>
                })}
            </SelectStyled>
        </>
    );
};

DevelopmentProgramFundingSelector.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func
};
